// src/components/KMUI/KPage.tsx

import {
  Card,
  CardContent,
  CardHeader,
  Collapse,
  Container,
  Paper,
} from '@mui/material'
import { ReactNode } from 'react'

import { useAppConfig } from '../../hooks'
import { Preloader } from '../dialog/Preloader'

type Props = {
  action?: ReactNode
  isLoading?: boolean
  children: ReactNode
  avatar?: ReactNode
  title?: string | ReactNode
  subheader?: string
}

export const KPage = ({
  action,
  avatar,
  isLoading,
  children,
  title,
  subheader,
  ...rest
}: Props) => {
  const { appConfig } = useAppConfig()
  const isWideScreen = appConfig?.wideScreen ?? true

  return isLoading === true ? (
    <Preloader isLoading={true} />
  ) : (
    <Collapse in={true}>
      <Paper elevation={0} sx={{ borderBottom: 'solid 1px #999' }}>
        <Card>
          <CardHeader
            {...rest}
            action={action}
            avatar={avatar}
            title={title}
            subheader={subheader}
          />

          <CardContent sx={{ minHeight: 'calc(100vh - 200px)' }}>
            <Container maxWidth={isWideScreen === true ? false : 'xl'}>
              {children}
            </Container>
          </CardContent>
        </Card>
      </Paper>
    </Collapse>
  )
}
